import React from "react";
import { withRouter } from 'react-router-dom';

// HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods';

// REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getToken, isAuthenticated } from '../../store/auth';
import { templateAction } from '../../store/templateSMS';
import { campanhaAction } from '../../store/campanha';

import { EMAIL } from '../../store/tipoListaEmail';

// COMPONENTS
import { Row, Column, IBox, Button, Select } from '../inspinia';
import UrlCampanhaSms from '../campanhaSms/urlCampanhaSms';

class EditarTemplateSms extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        id: '',
        nome: '',
        mensagem: '',
        empresa: { },
        url: ''
      },
      comboEmpresa: {
        results: undefined
    },
      maxLength: '160',
      loading: false
    };

    this.handleChangeTextArea = this.handleChangeTextArea.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeUrl = this.handleChangeUrl.bind(this);
    this.validacaoLimiteTextArea = this.validacaoLimiteTextArea.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onClickCancelar = this.onClickCancelar.bind(this);
  }

  componentDidMount() {
    this.LoadComboEmpresa();

    const { id } = this.props.match.params;

    if (id) {
      const url = `${c.API_CAMPAIGN_URL}/template/${id}`;
      callApi(url, { method: 'GET' }, (response) => {
              if (response && response.id) {

                const empresaId = response.idEmpresa?.id;

                this.setState({
                  form: {
                    id: response.id,
                    nome: response.nome,
                    mensagem: response.mensagem,
                    url: response.url,
                    empresa: empresaId != null ? { id: empresaId } : {},  
                  },
                });
              }
            });
          }
  }

  LoadComboEmpresa() {
    let self = this;

    const data = JSON.stringify({
      'id_produto': EMAIL
    });

    const url = `${c.API_BASE_URL}/company-user`;
    const options = {
      method: 'POST',
      body: data
    };

    self.setState({ ...self.state, loading: true })

    callApi(url, options, function (response) {
      self.setState({ ...self.state, loading: false, comboEmpresa: response });
    });
  }

  handleChangeEmpresa = (e) => {
    const raw = e.target.value;
    const id  = Number(raw);
  
    if (isNaN(id)) {
      return;
    }
  
    this.setState(prev => ({
      form: {
        ...prev.form,
        empresa: { id }
      }
    }));
  }

  validacaoLimiteTextArea() {
    const { url } = this.state.form;
    this.setState({ maxLength: url ? '135' : '160' });
  }

  handleChangeTextArea(e) {
    const mensagem = e.target.value;
    this.setState(prev => ({
      form: { ...prev.form, mensagem }
    }), this.validacaoLimiteTextArea);
  }

  handleChangeName(e) {
    const nome = e.target.value;
    this.setState(prev => ({
      form: { ...prev.form, nome }
    }));
  }

  handleChangeUrl(e) {
    const url = e.target.value;
    this.setState(prev => ({
      form: { ...prev.form, url }
    }), this.validacaoLimiteTextArea);
  }

  handleSave(e) {
    e.preventDefault();
    if (this.state.loading) return;

    this.setState({ loading: true });

    const validationMessage = this.validateForm();
    if (validationMessage) {
      c.TOASTER_ERROR_LINES(validationMessage);
      this.setState({ loading: false });
      return;
    }

    const form = { ...this.state.form, auth: this.props.auth };
    const editor = 'html';

    this.props.actions.template.salvarTemplate(form, editor)
      .then((response) => {
        const data = response?.data ?? response;

        c.TOASTER_SUCCESS("Template salvo com sucesso!");
        this.props.history.push("/campanha/template-sms");
      })
      .catch((error) => {
        console.log("ERRO BRUTO >>>", error);

        const status =
          error?.status ||
          error?.response?.status;

        const data =
          error?.data ||
          error?.response?.data ||
          error;

        let msg =
          data?.message ||
          data?.detail ||
          data?.title ||
          error?.message ||
          "Ocorreu um erro ao salvar o template.";

        if (status === 500) {
          msg = "Ocorreu um erro inesperado no servidor. Tente novamente mais tarde.";
        }

        c.TOASTER_ERROR(msg);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  validateForm() {
    const { form } = this.state;
    let message = "";
  
    if (!form.nome || form.nome.trim() === "") {
      message += "Campo 'Título da mensagem' é obrigatório.<br>";
    }
  
    if (!form.mensagem || form.mensagem.trim() === "") {
      message += "Campo 'Corpo do Template SMS' é obrigatório.<br>";
    }
  
    if (!form.empresa || !form.empresa.id) {
      message += "Campo 'Empresa' é obrigatório.<br>";
    }
  
    return message;
  }

  onClickCancelar() {
    this.setState({
      form: {
        id: '',
        nome: '',
        mensagem: '',
        empresa: { },
        url: ''
      },
    });

    this.props.history.push('/campanha/template-sms');
  }

  render() {
    const { form, maxLength } = this.state;
    const isEditando = !!this.props.match.params.id;

    return (
      <div>
        {/* TITLE */}
        <Row className="mb-4">
          <Column size="3">
            <h2 className="fs-20 fw-600 text-body m-0">
              {isEditando ? 'Editar Template SMS' : 'Novo Template SMS'}
            </h2>
          </Column>

          <Column size="9">
            <div className="input-group d-block fs-14 text-right">
              <button name="salvar" onClick={this.handleSave} type="button" className="btn btn-link px-3">Salvar</button>
            </div>
          </Column>
        </Row>

        {/* FORM */}
        <Row className="mb-3">
          <Column size="9">
            <IBox className="mb-0">
              <div>
                <label>Título da mensagem</label>
              </div>
              <div>
                <input onChange={this.handleChangeName} value={form.nome || ''} />
              </div>

              <div style={{ maxWidth: '161px', marginTop: '16px' }}>
                <Select
                  name="empresa"
                  selected={form.empresa.id}
                  data={this.state.comboEmpresa}
                  placeholder="Empresa"
                  onChange={this.handleChangeEmpresa}
                />
              </div> 

              <label className='mt-3'>Corpo do Template SMS</label>

              <div>
                <textarea
                  rows="12"
                  cols="40"
                  maxLength={maxLength}
                  value={form.mensagem || ''}
                  onChange={this.handleChangeTextArea}
                />
                <small className="form-text text-muted">
                  <i className="fa fa-info-circle" style={{ fontSize: "15px" }}></i><br />
                  A quantidade máxima de caracteres será determinada pela inserção da url.<br />
                  <strong>Com URL: 135 caracteres. <br />Sem URL: 160 caracteres.</strong>
                </small>
              </div>
            </IBox>
          </Column>

          <Column size="3" className="container">
            <Row>
              <Column size="12" className="container">
                <UrlCampanhaSms onChange={this.handleChangeUrl} value={form.url || ''} />
              </Column>
            </Row>
          </Column>
        </Row>

        <Row>
          <Column size="3">
            <Button className="btn btn-danger" onClick={this.onClickCancelar}>Cancelar</Button>
          </Column>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      template: bindActionCreators(templateAction, dispatch),
      arquivo: bindActionCreators(campanhaAction, dispatch)
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditarTemplateSms));
